import styled from 'styled-components';
const GifBadge = styled.span.withConfig({
  displayName: "GifBadge"
})(["position:absolute;bottom:", ";left:", ";background:rgba(0,0,0,0.6);color:", ";font-size:", ";font-weight:", ";border-radius:", ";padding:", ";line-height:1.4;pointer-events:none;"], ({
  theme
}) => theme.spotlight.spacing.xs, ({
  theme
}) => theme.spotlight.spacing.xs, ({
  theme
}) => theme.spotlight.color.surface, ({
  theme
}) => theme.spotlight.typography.fontSize.md, ({
  theme
}) => theme.spotlight.typography.fontWeight.bold, ({
  theme
}) => theme.spotlight.borderRadius.sm, ({
  theme
}) => `${theme.spotlight.spacing.xs} ${theme.spotlight.spacing.sm}`);
GifBadge.displayName = 'GifBadge';
export default GifBadge;